module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/assessment_achievements/3@2x_cf20b5649c47a1e366b68b5176204457.png";